import React from 'react'

import ServiceCTR from '../containers/services/ServiceCTR'

function Services() {
    return (
        <>
            <ServiceCTR />
        </>
    )
}

export default Services
